import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { listStockMain, listStockMainExport } from '@/api/stock.js';
import { listWarehouse } from '@/api/warehouse.js';
import { listBrand } from '@/api/brand.js';
import { listDealerUserManufacturer } from '@/api/manufacturer.js';
import YTable from '@/views/components/table/index.vue';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
export default {
  name: 'stock-detail-consign-index',
  components: {
    YTable: YTable,
    ElImageViewer: ElImageViewer
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.initialized) {
        vm.loadData();
      }
    });
  },
  data: function data() {
    return {
      dataList: [],
      // 订单列表
      dataLoading: false,
      initialized: false,
      searchForm: {
        orderNumber: null,
        // 订单编号
        state: null,
        // 状态 1=暂存,2=提交,3=部分发货,4=全部发货,5=作废,6=结单,7=待审核,8=暂存,9=驳回
        sellDateStart: null,
        // 销售日期
        sellDateEnd: null,
        distributorId: null,
        // 分销商ID
        dateRange: ['', ''],
        invoiceNumber: null,
        // 发票号
        remarks: null,
        // 备注
        isVirtualWarehouse: 2,
        page: 1,
        pageSize: 15,
        total: 0
      },
      searchFormExpand: false,
      // 是否展开搜索表单
      retailerList: [],
      previewImgURL: [],
      showViewer: false,
      dataTableCurrentRow: null,
      dataTableCacheName: 'SC-' + this.$route.name + '-data-table',
      columns: [{
        label: '仓库名称',
        prop: 'warehouseName',
        checked: true,
        width: 200
      }, {
        label: '规格ID',
        prop: 'specsId',
        checked: true,
        width: 100
      }, {
        label: '规格型号',
        prop: 'specificationModel',
        checked: true,
        width: 100
      }, {
        label: '产品主码',
        prop: 'barCode',
        checked: true,
        width: 150
      }, {
        label: '产品编码',
        prop: 'productNumber',
        checked: true,
        width: 150
      }, {
        label: '物资名称',
        prop: 'productName',
        checked: true,
        width: 200
      }, {
        label: '生产批号',
        prop: 'batchNumber',
        checked: true,
        width: 100
      }, {
        label: '序列号',
        prop: 'trackingCode',
        checked: true,
        width: 150
      }, {
        label: '累计消耗数量',
        prop: 'consumedQuantity',
        checked: true,
        width: 100
      }, {
        label: '库存数量',
        prop: 'stockQuantity',
        checked: true,
        width: 100
      }, {
        label: '可用数量',
        prop: 'normalQuantity',
        checked: true,
        width: 100
      }, {
        label: '寄售单价',
        prop: 'afterTaxPrice',
        checked: true,
        width: 150,
        formatter: function formatter(val) {
          return val.toFixed(2);
        }
      }, {
        label: '出库锁定',
        prop: 'issueLocking',
        checked: true,
        width: 100
      }, {
        label: '销售待审',
        prop: 'salesPendingApproval',
        checked: true,
        width: 100
      }, {
        label: '单位',
        prop: 'unit',
        checked: true,
        width: 100
      }, {
        label: '包装规格',
        prop: 'packSizes',
        checked: true,
        width: 100
      }, {
        label: '注册证号',
        prop: 'registrationNumber',
        checked: true,
        width: 150
      }, {
        label: '出厂检测报告',
        prop: 'url',
        checked: true,
        width: 100,
        slot: 'url'
      }, {
        label: '入库时间',
        prop: 'CreatedAt',
        checked: true,
        width: 150,
        type: 'time'
      }, {
        label: '生产厂家',
        prop: 'manufacturer',
        checked: true,
        width: 200
      }, {
        label: '生产日期',
        prop: 'manufacturerDate',
        checked: true,
        width: 100,
        type: 'date'
      }, {
        label: '有效期',
        prop: 'validityDate',
        checked: true,
        width: 100,
        type: 'date'
      }, {
        label: '灭菌批号',
        prop: 'sterilizationBatchNumber',
        checked: true,
        width: 100
      }, {
        label: '灭菌有效期',
        prop: 'sterilizationDate',
        checked: true,
        width: 100,
        type: 'date'
      }, {
        label: '品牌',
        prop: 'brandName',
        checked: true,
        width: 100
      }, {
        label: '产品线',
        prop: 'productLine',
        checked: true,
        width: 100
      }, {
        label: '分类',
        prop: 'classification',
        checked: true,
        width: 150
      }, {
        label: '产品状态',
        prop: 'state',
        checked: true,
        width: 100,
        formatter: function formatter(val) {
          if (val === 1) {
            return '<div class="state-dot"><i class="dot-green"></i>正常</div>';
          } else {
            return '<div class="state-dot"><i class="dot-red"></i>禁用</div>';
          }
        }
      }],
      brandList: [],
      uploadFilePrefixURL: null
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this;
                that.dataLoading = false;
                that.uploadFilePrefixURL = process.env.VUE_APP_OSS_URL + '/';
                _context.next = 5;
                return that.loadBrand();

              case 5:
                _context.next = 7;
                return that.loadWarehouse();

              case 7:
                _context.next = 9;
                return that.loadRetailer();

              case 9:
                // 设置默认经销商ID
                if (that.retailerList.length > 0) {
                  that.searchForm.manufacturerId4 = that.retailerList[0].ID;
                }

                if (that.initialized) {
                  _context.next = 13;
                  break;
                }

                _context.next = 13;
                return that.loadData();

              case 13:
                that.initialized = true;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    loadData: function loadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, query;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this2;
                that.dataList = [];
                that.dataLoading = true;
                query = JSON.parse(JSON.stringify(that.searchForm));
                _context2.next = 6;
                return listStockMain(query).then(function (res) {
                  that.dataList = that.listFormatter(res.list);
                  that.searchForm.total = res.total;

                  if (that.dataTableCurrentRow) {
                    that.$refs.dataTableRef.setCurrentRow(that.dataTableCurrentRow, true);
                  }
                }).catch(function (e) {});

              case 6:
                that.dataLoading = false;

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    dataExport: function dataExport() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, form;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this3;
                form = JSON.parse(JSON.stringify(that.searchForm));
                form.toExcel = 1;
                _context3.next = 5;
                return listStockMainExport(form).then(function (res) {
                  var blob = new Blob([res], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
                  }); // type这里表示xlsx类型

                  // type这里表示xlsx类型
                  var downloadElement = document.createElement('a');
                  var href = window.URL.createObjectURL(blob); // 创建下载的链接

                  // 创建下载的链接
                  downloadElement.href = href;
                  downloadElement.download = '库存明细.xlsx'; // 下载后文件名

                  // 下载后文件名
                  document.body.appendChild(downloadElement);
                  downloadElement.click(); // 点击下载

                  // 点击下载
                  document.body.removeChild(downloadElement); // 下载完成移除元素

                  // 下载完成移除元素
                  window.URL.revokeObjectURL(href); // 释放掉blob对象
                }).catch(function () {});

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    searchSubmit: function searchSubmit() {
      var that = this;
      that.searchForm.page = 1;
      that.searchForm.total = 0;
      that.loadData();
    },
    pageChange: function pageChange(page) {
      var that = this;
      that.searchForm.page = page;
      that.loadData();
    },
    sizeChange: function sizeChange(pageSize) {
      var that = this;
      that.searchForm.pageSize = pageSize;
      that.searchForm.page = 1;
      that.loadData();
    },
    loadBrand: function loadBrand() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that, query;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this4;
                query = {
                  page: 1,
                  pageSize: 9999
                };
                _context4.next = 4;
                return listBrand(query).then(function (res) {
                  that.brandList = res.list;
                }).catch(function (e) {});

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    loadWarehouse: function loadWarehouse() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this5;
                _context5.next = 3;
                return listWarehouse({
                  page: 1,
                  pageSize: 9999
                }).then(function (res) {
                  that.warehouseList = res.list;
                }).catch(function (e) {});

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    loadRetailer: function loadRetailer() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var that;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = _this6;
                that.manufacturerList = [];
                _context6.next = 4;
                return listDealerUserManufacturer({
                  page: 1,
                  pageSize: 9999
                }).then(function (res) {
                  that.retailerList = res.list;
                }).catch(function (e) {});

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    listFormatter: function listFormatter(dataList) {
      var resultList = [];
      dataList.forEach(function (row) {
        resultList.push({
          ID: row.ID,
          warehouseName: row.warehouse.status === 1 ? row.warehouse.name : row.warehouse.name + '(停用)',
          specsId: row.specs.ID,
          specificationModel: row.specs.specificationModel,
          productNumber: row.specs.productNumber,
          productName: row.main.productName,
          genericName: row.specs.genericName,
          batchNumber: row.batch_number,
          afterTaxPrice: row.afterTaxPrice,
          trackingCode: row.trackingCode,
          receiptQuantity: row.receiptQuantity,
          consumedQuantity: row.consumedQuantity,
          stockQuantity: row.stock_quantity,
          normalQuantity: row.normalQuantity,
          issueLocking: row.issueLocking,
          salesPendingApproval: row.salesPendingApproval,
          productPackageLocking: row.productPackageLocking,
          unit: row.specs.unit,
          packSizes: row.specs.packNum + row.specs.unit + '/' + row.specs.packUnit,
          registrationNumber: row.registrationNumber,
          CreatedAt: row.CreatedAt,
          manufacturer: row.main.manufacturer,
          supplier: row.main.supplier,
          manufacturerDate: row.manufacturer_date,
          validityDate: row.validity_date,
          sterilizationBatchNumber: row.sterilization_batch_number,
          sterilizationDate: row.sterilization_date,
          brandName: row.main.brandName,
          productLine: row.main.productLine,
          classification: row.main.classification,
          state: row.main.state,
          manufacturerName: row.manufacturerName,
          isConsign: row.isConsign,
          unqualifiedQuantity: row.unqualifiedQuantity,
          barCode: row.specs.barCode,
          shelfName: row.dealerShelf.shelfName,
          locationNumber: row.dealerLocation.locationNumber,
          companyName: row.subsidiary.companyName,
          cusCode: row.cusCode,
          consignmentPrice: row.specs.consignmentPrice,
          url: row.url
        });
      });
      return resultList;
    },
    closeViewer: function closeViewer() {
      var that = this;
      that.showViewer = false;
    },
    toPreview: function toPreview(url) {
      var that = this;
      var ext = url.substr(url.lastIndexOf('.')).toLowerCase();
      var imgExt = ['.jpg', '.jpeg', '.gif', '.png'];

      if (imgExt.includes(ext)) {
        that.previewImgURL = [that.uploadFilePrefixURL + url];
        that.showViewer = true;
      } else {
        var link = document.createElement('a');
        link.href = that.uploadFilePrefixURL + url;
        link.setAttribute('target', '_blank');
        link.click();
      }
    }
  }
};